module.exports = __webpack_public_path__ + "img/7-sdg-border@2x.6282038f.png";